<template>
  <div class="home-view">
    <!-- Hero Section with Search Bar -->
    <hero-section @scroll-to-services="scrollToServices" />

    <!-- Featured Properties Carousel (5 properties) -->
    <featured-properties v-if="$store.getters.isPropertiesSearchEnabled" />

    <!-- Key Firm Statistics -->
    <stats-bar />

    <!-- Services Section (Real Estate) -->
    <services-section />

    <!-- Why Choose León & Casallas -->
    <why-choose-us />

    <!-- Regional Coverage in Norte de Cundinamarca -->
    <coverage-section />

    <!-- Client Testimonials & Reviews -->
    <!--testimonials-section /-->

    <!-- Call to Action Banner -->
    <cta-banner />
  </div>
</template>

<script>
import HeroSection from '@/components/home/HeroSection.vue';
import FeaturedProperties from '@/components/home/FeaturedProperties.vue';
import StatsBar from '@/components/home/StatsBar.vue';
import ServicesSection from '@/components/home/ServicesSection.vue';
import WhyChooseUs from '@/components/home/WhyChooseUs.vue';
import CoverageSection from '@/components/home/CoverageSection.vue';
//import TestimonialsSection from '@/components/home/TestimonialsSection.vue';
import CtaBanner from '@/components/home/CtaBanner.vue';

export default {
  name: 'HomeView',
  components: {
    HeroSection,
    FeaturedProperties,
    StatsBar,
    ServicesSection,
    WhyChooseUs,
    CoverageSection,
    //TestimonialsSection,
    CtaBanner,
  },
  methods: {
    scrollToServices() {
      const el = document.getElementById('servicios');
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    },
  },
  mounted() {
    document.title = 'León & Casallas | Consultores & Gestores Inmobiliarios en el Norte de Cundinamarca';
  },
};
</script>

<style scoped>
.home-view {
  overflow-x: hidden;
  background-color: #ffffff;
}
</style>
